/// <reference path='../../../../../typings/index.d.ts' />

module Meevo.Plugins.ClientManualMerge  {
    'use strict';

    class ManualMergeDetailsSection implements angular.IComponentController {

        public securityKeys = Meevo.Components.Common.SecurityKeys;

        constructor(
            private securityService: Meevo.Components.Common.ISecurityService) { }

        static $inject = [
            'meevo.components.common.SecurityService'
        ];

        $onInit() {}

    }

    angular.module('meevo.plugins.clientManualMerge')
        .component('manualMergeDetailsSection', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/clientManualMerge/manualMergeDetailsSection/manualMergeDetailsSection.component.html',
            controller: ManualMergeDetailsSection,
            controllerAs: 'vm',
            bindings: {
                clientInfo: '<',
                isCentralOffice: '<'
            }
        });

}